import '../../../../node_modules/dropzone/dist/dropzone.css'
import vueDropzone from '../../../components/shared/DropzoneComponent.vue'

export default vueDropzone
